var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50065 2.25001C7.03652 2.25001 6.5914 2.43438 6.26321 2.76257C5.93502 3.09076 5.75065 3.53588 5.75065 4.00001V6.33334H10.4173C11.3838 6.33334 12.1673 7.11684 12.1673 8.08334V11.5833C12.1673 12.5498 11.3838 13.3333 10.4173 13.3333H4.58398C3.61749 13.3333 2.83398 12.5498 2.83398 11.5833V8.08334C2.83398 7.11684 3.61749 6.33334 4.58398 6.33334V4.00001C4.58398 3.22646 4.89127 2.4846 5.43826 1.93762C5.98524 1.39063 6.7271 1.08334 7.50065 1.08334C8.2742 1.08334 9.01606 1.39063 9.56304 1.93762C10.11 2.4846 10.4173 3.22646 10.4173 4.00001C10.4173 4.32218 10.1561 4.58334 9.83398 4.58334C9.51182 4.58334 9.25065 4.32218 9.25065 4.00001C9.25065 3.53588 9.06628 3.09076 8.73809 2.76257C8.4099 2.43438 7.96478 2.25001 7.50065 2.25001ZM4.58398 7.50001C4.26182 7.50001 4.00065 7.76118 4.00065 8.08334V11.5833C4.00065 11.9055 4.26182 12.1667 4.58398 12.1667H10.4173C10.7395 12.1667 11.0006 11.9055 11.0006 11.5833V8.08334C11.0006 7.76118 10.7395 7.50001 10.4173 7.50001H4.58398ZM6.33398 9.83334C6.33398 9.18901 6.85632 8.66668 7.50065 8.66668C8.14498 8.66668 8.66732 9.18901 8.66732 9.83334C8.66732 10.4777 8.14498 11 7.50065 11C6.85632 11 6.33398 10.4777 6.33398 9.83334Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lockOpen.1e9c07b7634a50373588d5e59cc521c8.svg";
export { ForwardRef as ReactComponent };